import React from "react";
import { Globe } from "lucide-react";
import { SUB } from "../styles";
import type { LocaleIconProps } from "../types";

export default function LocaleIcon({ locale, large }: LocaleIconProps) {
  if (locale.flagSrc) {
    const dims = large ? { width: 28, height: 20 } : { width: 24, height: 16 };
    return (
      <img
        src={locale.flagSrc}
        alt={locale.label}
        style={{
          ...dims,
          objectFit: "cover",
          borderRadius: 2,
          border: "1px solid rgba(0,0,0,0.1)",
          display: "block",
          flexShrink: 0,
        }}
      />
    );
  }
  return (
    <Globe
      size={large ? 22 : 18}
      strokeWidth={1.8}
      style={{ flexShrink: 0, color: SUB }}
    />
  );
}